import React from "react"
import {BaseButton, SecondaryButton} from "components/buttons"
import {BasePopup} from "components/popup"
import CampusSelect from "components/CampusSelect"
import ProgramSelect from "components/ProgramSelect"
import ProgramVersionSelect from "components/ProgramVersionSelect"
import {BaseDatePicker} from "components/DateTimePicker"
import {Col, Row} from "antd"
import styles from "./AcademicTrack.module.css"
import {FormLabel} from "components/Form"

type ResyncPopupState = {
    isVisible: boolean
    academicTrackIds: number[]
    campuses: any[]
    programs: any[]
    programVersions: any[]
    startDate: any
}

type Props = {
    isVisible: boolean
    isSubmitting: boolean
    resyncPopup: ResyncPopupState
    selectedAcademicTrackNames: string[]
    onClose: () => void
    onChange: (key: string, value: any) => void
    onConfirm: () => void
}

export function ResyncPhaseAndShiftPopup({
    isVisible,
    isSubmitting,
    resyncPopup,
    selectedAcademicTrackNames,
    onClose,
    onChange,
    onConfirm
}: Props) {
    const campusIds = (resyncPopup.campuses || []).map((item) => item.id).filter(Boolean)
    const programIds = (resyncPopup.programs || []).map((item) => item.id).filter(Boolean)

    const hasCampusError = !campusIds.length && isVisible

    return (
        <BasePopup isShow={isVisible} onClose={onClose} width="70vw">
            <div className={styles.popupContent}>
                <div className={styles.popupTitle}>
                    Resync Phases And Shifts
                    {selectedAcademicTrackNames.length > 0 && (
                        <div className={styles.selectedTracksText}>
                            Selected: {selectedAcademicTrackNames.join(", ")}
                        </div>
                    )}
                </div>
                <Row gutter={[16, 16]}>
                    <Col span={12}>
                        <FormLabel label="Campuses" isRequired />
                        <CampusSelect
                            isMulti
                            isClearable
                            value={resyncPopup.campuses}
                            onChange={(value) => onChange("campuses", value || [])}
                            placeholder="Select Campuses"
                        />
                        {hasCampusError && <div className={styles.validationText}>Campus is required</div>}
                    </Col>
                    <Col span={12}>
                        <FormLabel label="Programs" />
                        <ProgramSelect
                            isMulti
                            isClearable
                            value={resyncPopup.programs}
                            campusId={campusIds}
                            onChange={(value) => onChange("programs", value || [])}
                            placeholder="Select Programs"
                        />
                    </Col>
                    <Col span={12}>
                        <FormLabel label="Program Versions" />
                        <ProgramVersionSelect
                            isMulti
                            isClearable
                            value={resyncPopup.programVersions}
                            campusIds={campusIds}
                            programId={programIds}
                            onChange={(value) => onChange("programVersions", value || [])}
                            placeholder="Select Program Versions"
                        />
                    </Col>
                    <Col span={12}>
                        <FormLabel label="Start Date" />
                        <BaseDatePicker
                            value={resyncPopup.startDate}
                            onChange={(value) => onChange("startDate", value)}
                        />
                    </Col>
                </Row>
                <div className={styles.popupFooter}>
                    <SecondaryButton title={"Cancel"} onClick={onClose} />
                    <BaseButton title={"Confirm"} onClick={onConfirm} loading={isSubmitting} />
                </div>
            </div>
        </BasePopup>
    )
}
